import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { AnimatePresence, motion } from "framer-motion";

interface BaseMenuItemProps {
  title: string;
  url?: string;
  subMenuContent?: React.ReactNode;
  itemIndex: number;
}

export default function BaseMenuItem({
  itemIndex,
  title,
  url,
  subMenuContent,
}: BaseMenuItemProps) {
  return (
    <Disclosure defaultOpen={itemIndex === 0}>
      {({ open }) => (
        <>
          <DisclosureButton
            className="
              xpy-4
              xw-full
              xfont-grotesque xfont-bold
              xtext-4xl


              xflex xjustify-between xitems-center
            "
            {...(url && {
              onClick: (e) => {
                e.preventDefault();
                window.location.href = url;
              },
            })}
          >
            {title}
            {subMenuContent && (
              <ChevronDownIcon
                className={clsx("xsize-12", open && "xrotate-180")}
              />
            )}
          </DisclosureButton>
          {subMenuContent && (
            <DisclosurePanel className="">{subMenuContent}</DisclosurePanel>
          )}
        </>
      )}
    </Disclosure>
  );
}
